import { useMutation } from "@tanstack/react-query";
import { API_URL } from "src/Utils/API";

export interface DemoRequestPayload {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  restaurantName: string;
  cityName: string;
  subscriptionTier: string;
  message: string | null;
}

export const useCreateDemoRequest = () =>
  useMutation({
    mutationFn: async (payload: DemoRequestPayload) => {
      const response = await fetch(`${API_URL}/requests`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (response.status === 201) {
        return;
      }

      const data = await response.json();
      if (response.status === 409) {
        throw new Error(data.message ?? "conflict");
      }

      return data;
    },
  });
